module.exports = __webpack_public_path__ + "static/0030-25f98c2a97c2300a0a39fc830e07c8eb.png";